// src/contexts/ToastContext.js
import React, { createContext, useContext, useState, useCallback } from "react";
import styles from "../styles/components/common/Toast.module.css";

///////////////////////////// Toast Component
export const Toast = ({ message, type = "success", onClose }) => {
  return (
    <div
      className={`${styles.toast} ${styles[type]}`}
      role="alert"
      aria-live="assertive"
    >
      <span className={styles.message}>{message}</span>
      <button
        onClick={onClose}
        aria-label="Close notification"
        className={styles.closeBtn}
      >
        ×
      </button>
    </div>
  );
};

///////////////////////// Context
export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback(({ message, type = "success", duration = 3000 }) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);

    if (duration > 0) {
      setTimeout(() => {
        removeToast(id);
      }, duration);
    }
  }, [removeToast]);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className={styles.toastContainer}>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
